import { TApplicationsPublicResponse } from './fetch-applications-public.types'

export const mockedApplicationsPublicData: TApplicationsPublicResponse = {
  has_prev: 0,
  has_next: 0,
  total: 2,
  page: 1,
  pages: 1,
  items:[
    {
      created_at: '',
      developer_name: '',
      icon: '',
      short_description: '',
      tenants: [],
      updated_at: '',
      url: '',
      status_change_date: "2021-09-22 13:31:41.454129+03:00",
      company_name: "test",
      id: "efc90a7e-2a0c-4d99-b969-50a5f6f01f82",
      status: "REGISTERED",
      name: "new-app2",
      application_types: [
        {
          name: "App name",
          id: "94206f49-1844-4998-bb3b-04d0bdd77be2"
        }
      ],
      categories: [
        {
          name: "Categories name",
          id: "94206f49-1844-4998-bb3b-04d0bdd77baa"
        }
      ],
      products: [
        {
          name: "Products nme",
          id: "94206f49-1844-4998-bb3b-04d0bdd77b23"
        }
      ]
    },
    {
      created_at: '',
      developer_name: '',
      icon: '',
      short_description: '',
      tenants: [],
      updated_at: '',
      url: '',
      status_change_date: "2021-09-22 13:31:23.352162+03:00",
      company_name: "test",
      id: "a242297d-a85b-47b2-834e-7fb44490d18b",
      status: "REGISTERED",
      name: "new-app",
      application_types: [],
      categories: [],
      products: []
    }
  ]
}
